<form
  [formGroup]="resetPasswordForm"
  *ngIf="!isPasswordResetSuccessful; else passwordResetSuccess"
>
  <h1 class="login-title mb-2">Reset Password</h1>

  <div class="form-row md">
    <div class="col-9">
      <span class="input-label">Email</span>

      <input
        type="text"
        class="input"
        formControlName="email"
        placeholder="Enter Email"
        [class.is-invalid]="
          resetPasswordForm.get('email')?.invalid &&
          resetPasswordForm.get('email')?.touched
        "
      />
    </div>

    <div class="col-3">
      <span class="input-label">Pin</span>
      <input
        type="text"
        placeholder="Pin"
        formControlName="pin"
        [class.is-invalid]="
          resetPasswordForm.get('pin')?.invalid &&
          resetPasswordForm.get('pin')?.touched
        "
      />
    </div>

    <div
      class="invalid-feedback col-12 d-block text-left"
      *ngIf="
        resetPasswordForm.get('email')?.invalid &&
        resetPasswordForm.get('email')?.touched
      "
    >
      <span *ngIf="resetPasswordForm.get('email')?.errors?.required"
        >Email field is required</span
      >
      <span *ngIf="resetPasswordForm.get('email')?.errors?.pattern"
        >Must be email format like: 'example&#64;gmail.com'
      </span>
    </div>

    <div
      class="invalid-feedback col-12 d-block text-left"
      *ngIf="
        resetPasswordForm.get('pin')?.invalid &&
        resetPasswordForm.get('pin')?.touched
      "
    >
      <div *ngIf="resetPasswordForm.get('pin')?.errors?.required">
        Pin field is required
      </div>
      <div
        *ngIf="
          (resetPasswordForm.get('pin')?.errors?.minlength &&
            resetPasswordForm.get('pin')?.errors?.minlength.requiredLength) ||
          (resetPasswordForm.get('pin')?.errors?.maxlength &&
            resetPasswordForm.get('pin')?.errors?.maxlength.requiredLength)
        "
      >
        Pin length must be
        {{
          resetPasswordForm.get('pin')?.errors?.minlength?.requiredLength ||
            resetPasswordForm.get('pin')?.errors?.maxlength?.requiredLength
        }}
        characters
      </div>
    </div>
  </div>

  <div class="mt-3 pt-2">
    <button
      type="submit"
      class="button blue w-100"
      [disabled]="!resetPasswordForm.valid"
      (click)="onSubmit()"
    >
      Reset Password
    </button>
  </div>
</form>

<ng-template #passwordResetSuccess>
  <div class="reset-password-success">
    <div class="">
      <h4 class="reset-password-success-heading">Password Reset Success!</h4>
      <p class="reset-password-success-text">
        A new password has been sent to your email. Please check your email and
        follow the instructions.
      </p>
    </div>
  </div>
</ng-template>
